<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="!isLoginScreen"
      class="p-4 body-card"
    >
      <v-list class="py-0">
        <v-img height="100%" src="./assets/background/wallpaper-name.png">
          <v-list-item
            dark
            cd
            color="white"
            v-if="currentUser.user"
            class="margin-top-max"
          >
            <v-list-item-content class="mt-13 p-8">
              <v-row
                class="mb-1"
                :align="center"
                :justify="space - between"
                no-gutters
              >
                <v-col cols="10">
                  <div>
                    <h2 class="mb-6">{{ currentUser.user.name }}</h2>
                    <span class="font-weight-bold text-caption"
                      >Último ingreso:
                      <span class="text-no-wrap">{{
                        LoginTime | fmtDate()
                      }}</span></span
                    >
                  </div>
                </v-col>
                <v-col cols="2" style="padding-left: 15px;">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="logout" v-bind="attrs" v-on="on">
                        mdi-logout
                      </v-icon>
                    </template>
                    <span>Cerrar sesión</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-list-item-subtitle
                v-if="
                  currentUser.user.customerCurrent &&
                  currentUser.user.customerCurrent.customerName
                "
              >
                <v-autocomplete
                  v-model="showString"
                  :items="OrderCustomerName"
                  item-text="customerName"
                  auto-select-first
                  @change="changeCustomerCurrent"
                ></v-autocomplete>
              </v-list-item-subtitle>
              <!-- <v-label v-else>no tiene organización asignada</v-label> -->
            </v-list-item-content>
          </v-list-item>
        </v-img>
      </v-list>

      <v-divider></v-divider>
      <div class="border-top-green">
        <v-list dense :key="getKeyRouterView" class="bg-gray">
          <v-list-item color="#27E96A" link to="/calls">
            <v-list-item-action>
              <v-icon color="#27e96a">mdi-phone-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-complementary-color"
                ><h3>Llamadas</h3></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            color="#27E96A"
            link
            v-if="isClientAdmin || isSuperAdmin"
            to="/recordings"
          >
            <v-list-item-action>
              <v-icon color="#27e96a">mdi-ear-hearing</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-complementary-color"
                ><h3>Replay</h3></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item color="#27e96a" link v-if="isSuperAdmin" to="/customers">
            <v-list-item-action>
              <v-icon color="#27e96a">mdi-face-agent</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-complementary-color"
                ><h3>Clientes</h3></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            color="#27e96a"
            link
            v-if="isClientAdmin || isSuperAdmin"
            to="/apikeys"
          >
            <v-list-item-action>
              <v-icon color="#27e96a">mdi-key-chain</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-complementary-color"
                ><h3>Apis keys</h3>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            color="#27e96a"
            link
            v-if="isClientAdmin || isSuperAdmin"
            to="/users"
          >
            <v-list-item-action>
              <v-icon color="#27e96a">mdi-account-group</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-complementary-color"
                ><h3>Usuarios</h3></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            color="#27e96a"
            link
            v-if="isClientAdmin || isSuperAdmin"
            to="/task"
          >
            <v-list-item-action>
              <v-icon color="#27e96a">mdi-account-box-multiple</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-complementary-color"
                ><h3>Tareas</h3></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            color="#27e96a"
            link
            v-if="isClientAdmin || isSuperAdmin"
            to="/storagecloud"
          >
            <v-list-item-action>
              <v-icon color="#27e96a">mdi-database</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-complementary-color"
                ><h3>Cloud Storage</h3></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            link
            color="#27e96a"
            v-if="isClientAdmin || isSuperAdmin"
            to="/filenameformat"
          >
            <v-list-item-action>
              <v-icon color="#27e96a">mdi-folder-information-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-complementary-color"
                ><h3>Formato de Etiqueta</h3></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            color="#27e96a"
            link
            v-if="isClientAdmin || isSuperAdmin"
            to="/rptengine"
          >
            <v-list-item-action>
              <v-icon color="#27e96a">mdi-desktop-classic</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-complementary-color"
                ><h3>Instancias</h3></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            color="#27e96a"
            link
            v-if="isClientAdmin || isSuperAdmin"
            to="/configuration"
          >
            <v-list-item-action>
              <v-icon color="#27e96a">mdi-cog-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="text-complementary-color"
                ><h3>Configuración</h3></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="#262627"
      dark
      v-if="!isLoginScreen && currentUser.user"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        <span class="hidden-sm-and-down">
          <Logo class="mt-2" />
        </span>
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>
    <v-content class="body-card-secondary">
      <v-container fluid>
        <router-view :key="getKeyRouterView"></router-view>
        <global-error />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";
import { mapGetters, mapState } from "vuex";
import GlobalError from "./components/globalError.vue";
import { fmtDate } from "@/lib/filters";
import Logo from "./assets/iconsMedia/logo-replay.svg";

export default {
  components: {
    GlobalError,
    Logo,
  },
  computed: {
    ...mapGetters("auth", ["isSuperAdmin", "isClientAdmin", "userName"]),
    ...mapState("auth", ["currentUser", "currentUser"]),
    isLoginScreen() {
      return this.$route.meta?.noauth;
    },
    OrderCustomerName() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.currentUser.user.customers.sort((a, b) => {
        return a.customerName.localeCompare(b.customerName);
      });
    },
    getKeyRouterView() {
      const key = this.currentUser.user?.customerCurrent?.customerId ?? 0;
      return key;
    },
    LoginTime() {
      const loginDate =
        this.currentUser.firebaseUser?.metadata?.lastSignInTime ?? "";
      return loginDate ? new Date(loginDate).toISOString() : "";
    },
    //Esta funcion computada resuelve el bug. Cuando el v-model del autcomplete quedaba vacio la dejaba como undefinida por ende me ocultaba el componete(autocomplete).
    showString: {
      get() {
        return this.currentUser.user.customerCurrent.customerName;
      },
      set(val) {
        if (typeof val === "undefined") return null;
        return this.currentUser.user.customerCurrent.customerName;
      },
    },
  },
  methods: {
    changeCustomerCurrent(value) {
      if (value) {
        const customer = this.currentUser.user.customers.find(
          (e) => e.customerName === value
        );
        this.$store.commit("auth/SET_CURRENT_CUSTOMER_USER", customer);
      }
    },

    logout() {
      firebase
        .auth()
        .signOut()
        .finally(() => {
          this.$store.commit("auth/CLEAR_ALL");
          this.$router.push("/login");
        });
    },
  },
  data: () => ({
    drawer: null,
    userPrefs: false,
    data: "",
  }),
  filters: {
    fmtDate,
  },
};
</script>
<style lang="scss">
@import "./styles/global.scss";
.v-navigation-drawer__content {
  background: $background-complementary;
}
.paddingHeader {
  padding-top: auto;
  margin-left: 11px;
  margin-top: 10px;
}

.scrollVList {
  height: 700px;
  overflow-y: auto;
}
</style>
